import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; 

import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { CostCenterComponent } from './cost-center/cost-center.component';
import { InpatientComponent } from './cost-center/inpatient/inpatient.component';
import { SmtSharedModule } from '../../../shared/module/shared.module';
import { StaffingRoutingModule } from './staffing-routing.module';
import { StaffingComponent } from './staffing.component';
import { DetailsTabComponent } from './cost-center/details-tab/details-tab.component';
import { AncillaryComponent } from './cost-center/ancillary/ancillary.component';
import { GeneralTabComponent } from './cost-center/general-tab/general-tab.component';
import { StaffingGridComponent } from './staffing-grid/staffing-grid.component';
import { StaffingGridValueComponent } from './staffing-grid/cells/staffing-grid-value/staffing-grid-value.component';
import { VariableJobsShiftGridComponent } from './staffing-grid/grids/variable-jobs-shift-grid/variable-jobs-shift-grid.component';
import { BaseGridComponent } from './staffing-grid/base-grid/base-grid.component';
import { BaseShiftBlockGridComponent } from './staffing-grid/base-grid/base-shiftblock-grid/base-shiftblock-grid.component';
import { FixedJobsShiftGridComponent } from './staffing-grid/grids/fixed-jobs-shift-grid/fixed-jobs-shift-grid.component';
import { ButtonsComponent } from './staffing-grid/buttons/buttons.component';
import { ShiftBlockInputComponent } from './staffing-grid/shiftblock-input/shiftblock-input.component';
import { VariableShiftblocksComponent } from './staffing-grid/shiftblock-input/variable-shiftblocks/variable-shiftblocks.component';
import { VariableJobUosGridComponent } from './staffing-grid/grids/variable-job-uos-grid/variable-job-uos-grid.component';
import { AddOnsGridComponent } from './staffing-grid/grids/add-ons-grid/add-ons-grid.component';
import { AcuityGridComponent } from './staffing-grid/grids/acuity-grid/acuity-grid.component';
import { StaffingGridModalComponent } from './staffing-grid/staffing-grid-modal/staffing-grid-modal.component';

@NgModule({
    declarations: [
        CostCenterComponent,
        InpatientComponent,
        StaffingComponent,
        DetailsTabComponent,
        AncillaryComponent,
        GeneralTabComponent,
        StaffingGridComponent,
        StaffingGridValueComponent,
        VariableJobsShiftGridComponent,
        BaseGridComponent,
        BaseShiftBlockGridComponent,
        FixedJobsShiftGridComponent,
        ButtonsComponent,
        ShiftBlockInputComponent,
        VariableShiftblocksComponent,
        VariableJobUosGridComponent,
        AddOnsGridComponent,
        AcuityGridComponent,
        StaffingGridModalComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        InfiniteScrollModule,
        ReactiveFormsModule,
        SmtSharedModule,
        StaffingRoutingModule
    ]
})
export class StaffingModule { }
